import React, { useState } from "react";
import TableMain from "../Common/table/TableMain";
import { getLastPage } from "../../utils/getLastPage";
import { useTranslation } from "react-i18next";
import RepurchaseTableFilter from "../Common/table/RepurchaseTableFilter";
import { Link } from "react-router-dom";

const RepurchaseTable = (props) => {
  const { t } = useTranslation();
  const purchaseHeaders = [
    "invoice_no",
    "purchase_for",
    "tracking_id",
    "totalAmount",
    "totalBV",
    "paymentMethod",
    "purchaseDate",
    "status",
  ];
  const rbvHeaders = [
    "invoice_no",
    "purchase_for",
    "tracking_id",
    "totalAmount",
    "totalRV",
    "paymentMethod",
    "purchaseDate",
    "status",
  ];
  const headers = props.activeTab !== "rbvPack" ? purchaseHeaders : rbvHeaders;

  const reportPurchaseHeaders = [
    t("invoice_no"),
    t("purchase_for"),
    t("tracking_id"),
    t("totalAmount"),
    t("totalBV"),
    t("paymentMethod"),
    t("purchaseDate"),
    t("status"),
  ];

  const reportRbvHeaders = [
    t("invoice_no"),
    t("purchase_for"),
    t("tracking_id"),
    t("totalAmount"),
    t("totalRV"),
    t("paymentMethod"),
    t("purchaseDate"),
    t("status"),
  ];

  const reportHeaders = props.activeTab !== "rbvPack" ? reportPurchaseHeaders : reportRbvHeaders;

  const lastPage = getLastPage(props.itemsPerPage, props?.data?.totalCount);

  return (
    <div className="ewallet_table_section">
      <div className="ewallet_table_section_cnt">
        <div className="ewallet_table_section_cnt">
          <div className="ewallet_table_section_cnt_tab_head">
            <Link
              className={`ewallet_tab_btn ${
                props.activeTab === "repurchase" ? "active" : ""
              }`}
              onClick={() => props.setActiveTab("repurchase")}
            >
              Fast Track
            </Link>
            <Link
              className={`ewallet_tab_btn ${
                props.activeTab === "rbvPack" ? "active" : ""
              }`}
              onClick={() => props.setActiveTab("rbvPack")}
            >
              Repurchase
            </Link>
          </div>
        </div>
        <RepurchaseTableFilter
          headers={headers}
          data={props.data?.data}
          type={props.type}
          reportHeaders={reportHeaders}
          activeTab={props.activeTab}
        />
        <div className="table-responsive min-hieght-table">
          <TableMain
            headers={headers}
            data={props.data?.data}
            startPage={1}
            currentPage={props.currentPage}
            totalPages={lastPage}
            type={props.type}
            itemsPerPage={props.itemsPerPage}
            setItemsPerPage={props.setItemsPerPage}
            setCurrentPage={props.setCurrentPage}
            setEpinSortOptions={props.setSortOptions}
            activeTab={props.activeTab}
          />
        </div>
      </div>
    </div>
  );
};

export default RepurchaseTable;
